export default "__VITE_ASSET__2d72dbd2__"